/**
 * @ngdoc service
 * @name contacts.workflows:doContactShipping
 *
 * @description
 *
 */
angular
    .module('festzelt-os.contacts')
    .factory('prepareContactPickup', [
        'ContactActionsService',
        prepareContactPickup
    ]);

function prepareContactPickup(ContactActionsService) {
    return {
        key: 'prepare-contact-pickup',
        title: 'Prepare Pickup',
        level: 'highlight',
        icon: 'envelope-square',
        order: 100,
        action(contact) {
            return ContactActionsService.startPreparePickupWorkflow(contact);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/contacts/workflows/detailed-view/prepare-pickup.js